module.exports = __webpack_public_path__ + "static/media/import-icon.ac9a8f00.svg";